import Pop from 'components/Popover/Pop';
import Text from 'components/Text/Text';
import { useLoggedUserRestaurants } from 'hooks/useLoggedUserRestaurants';
import React from 'react';
import { trueWordEnding } from 'utils/helpers';
import style from './RestaurantsList.module.scss';

interface IRestaurantsListRestaurant {
	id: string;
	restaurantName: string | null;
}

interface IRestaurantsList {
	restaurants: IRestaurantsListRestaurant[];
}

const RestaurantsList: React.FC<IRestaurantsList> = ({ restaurants }) => {
	const restaurantString = trueWordEnding(restaurants.length, 'singularRestaurantLabel', 'pluralRestaurantsLabel');

	const accessibleRestaurants = useLoggedUserRestaurants(restaurants);

	const RestaurantsContent = () => {
		return (
			<div className={style.container} data-test="RestaurantsContent">
				{accessibleRestaurants.map((el) => (
					<div className={style.item} key={el.id}>
						<Text translationKey={el.restaurantName} size="xs" />
					</div>
				))}
			</div>
		);
	};

	return (
		<data data-test="RestaurantsList">
			{accessibleRestaurants.length > 1 ? (
				<Pop placement="rightTop" content={<RestaurantsContent />} trigger="click">
					<div className={style.showListBtn}>
						<Text
							className={style.bottomDotted}
							translationNameSpace="listing"
							translationKey={restaurantString}
							translationOptions={{
								count: accessibleRestaurants.length,
							}}
							theme="secondary"
							align="right"
							display="inline"
							withTooltip={true}
						/>
					</div>
				</Pop>
			) : (
				<Text
					translationKey={accessibleRestaurants.length ? accessibleRestaurants[0].restaurantName : '-'}
					align="right"
					withTooltip={true}
				/>
			)}
		</data>
	);
};

export default React.memo(RestaurantsList);
